import { render, staticRenderFns } from "./supplyChainForm.vue?vue&type=template&id=f83eaad2&scoped=true&"
import script from "./supplyChainForm.vue?vue&type=script&lang=js&"
export * from "./supplyChainForm.vue?vue&type=script&lang=js&"
import style0 from "./supplyChainForm.vue?vue&type=style&index=0&id=f83eaad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83eaad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f83eaad2')) {
      api.createRecord('f83eaad2', component.options)
    } else {
      api.reload('f83eaad2', component.options)
    }
    module.hot.accept("./supplyChainForm.vue?vue&type=template&id=f83eaad2&scoped=true&", function () {
      api.rerender('f83eaad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/supplyChainForm.vue"
export default component.exports